import React, { useEffect, useState } from 'react';
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { UseAuthContext } from '../../context/AuthContext';

const containerStyles = {
    display: "flex",
    paddingLeft: "10px"
}

// Maps each API definition to the reverse-proxy path prefix that nginx (and the local
// setupProxy.js dev server) use to route requests to the correct backend. The backends'
// own OpenAPI specs declare their own absolute host (unaware of this prefix), so
// "Try it out" requests must have this prefix re-applied after the host is stripped,
// otherwise they fall through to the SPA's catch-all route and return index.html.
const definitionPrefixes = {
    "AM API Definition": "/v3",
    "Importer API Definition": "/importer",
    "DAWA API Definition": "/dawa"
};

export default function Swagger() {
    const { token } = UseAuthContext();
    const [apiToken, setApiToken] = useState();
    const [urlLink, setUrlLink] = useState("AM API Definition");
    useEffect(() => {
        setApiToken(token);
    }, [token])

    const requestInterceptor = (req) => {
        req.headers.Authorization = `Bearer ${apiToken}`;
        if (!req.url.includes("api-docs")) {
            const parsedUrl = new URL(req.url, window.location.origin);
            let path = parsedUrl.pathname + parsedUrl.search;
            // Only re-apply the selected tab's proxy prefix if the backend-declared
            // operation path doesn't already start with one of nginx's known upstream
            // route prefixes. Some backend operations (e.g. AM Importer's
            // "/dawa/change-groups") already embed a segment that matches a *different*
            // backend's nginx route (e.g. /dawa/), so blindly prepending the tab's
            // prefix would misroute the request to the wrong upstream entirely.
            const knownPrefixes = ["/api/", "/dawa/", "/importer/", "/v3/", "/change-groups", "/delta-jobs/"];
            const alreadyPrefixed = knownPrefixes.some((p) => path.startsWith(p));
            if (!alreadyPrefixed) {
                const prefix = definitionPrefixes[urlLink] || "";
                if (prefix) {
                    path = prefix + path;
                }
            }
            req.url = path;
        }
        return req;
    };

    const handleClick = (e) => {
        setUrlLink( e.target.value);
    }
    
    return (
        <div>
            <div><hr></hr></div>
            <div style={containerStyles}>
                 <div style={containerStyles}>   
                 <select id="view" className="form-control form-control-sm"
                    value={urlLink} onChange={handleClick}>
                    <option value="AM API Definition">Show AM API Definition</option>
                    <option value="Importer API Definition">Show Importer API Definition</option>
                    <option value="DAWA API Definition">Show DAWA API Definition</option>
                </select>
            </div>
            </div>
            {apiToken && <SwaggerUI url={(urlLink === "Importer API Definition"? "/importer/api-docs" : (urlLink === "AM API Definition" ? "/v3/api-docs": "/dawa/api-docs"))}
                requestInterceptor={requestInterceptor} />}
        </div>
    )
}